import SubcategoryPage from '@/components/template/SubcategoryPage';

const InvillaStool = () => {
  const products = [
    {
      title: "Invilla Stool Classic",
      imageSrc: "https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?auto=format&fit=crop&q=80",
      url: "/proizvodi/invilla-stool-classic"
    },
    {
      title: "Invilla Stool Modern",
      imageSrc: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&q=80",
      url: "/proizvodi/invilla-stool-modern"
    },
    {
      title: "Invilla Stool Premium",
      imageSrc: "https://images.unsplash.com/photo-1581539250439-c96689b516dd?auto=format&fit=crop&q=80",
      url: "/proizvodi/invilla-stool-premium"
    }
  ];

  return (
    <SubcategoryPage
      title="Invilla Stool"
      description="Elegantni in luksuzni Invilla stolčki, ki dodajo pridih prefinjene elegance vašemu prostoru."
      heroImage="https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default InvillaStool;